module.exports = __webpack_public_path__ + "static/media/AMENDMENTS - Notice of Proposal to Revoke and Apply Conditions v3.e9a3e09f.pdf";